/**
 * A small modal over the lobby (color, Players, bots): the lobby stays visible
 * behind a dimmed backdrop. A ✕ in the top-right and a tap outside both close
 * it without changes; there is no Cancel or Done, because picking a value
 * applies it and closes.
 */
import React from 'react'
import { View, Text, TouchableOpacity, Pressable, ScrollView, useWindowDimensions } from 'react-native'
import { AppModal } from '../../ui/AppModal'

export function LobbyPopup({ visible, title, subtitle, closeLabel, closeTestID, onClose, testID, maxWidth = 420, scroll = false, children }: {
  visible: boolean
  title: string
  /** One line under the title. */
  subtitle?: string
  /** Accessibility label for the ✕ and the backdrop, e.g. "Close color picker". */
  closeLabel: string
  closeTestID?: string
  onClose: () => void
  testID?: string
  maxWidth?: number
  /** Long content (the bot list): the body scrolls inside the popup. */
  scroll?: boolean
  children: React.ReactNode
}) {
  const { height } = useWindowDimensions()
  return (
    <AppModal visible={visible} animationType="fade" transparent onRequestClose={onClose}>
      <View className="flex-1 items-center justify-center px-5" style={{ backgroundColor: 'rgba(0,0,0,0.6)' }}>
        <Pressable accessibilityLabel={closeLabel} onPress={onClose} style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0 }} />
        <View testID={testID} className="w-full rounded-xl border-2 border-olive bg-paper p-4" style={{ maxWidth }}>
          <View className="flex-row items-center justify-between mb-2">
            <Text accessibilityRole="header" className="text-ink font-stencil text-base uppercase">{title}</Text>
            <TouchableOpacity testID={closeTestID} onPress={onClose} accessibilityLabel={closeLabel} accessibilityRole="button" hitSlop={8}
              style={{ minHeight: 32, minWidth: 32, alignItems: 'center', justifyContent: 'center' }}>
              <Text className="text-ink-soft text-xl">✕</Text>
            </TouchableOpacity>
          </View>
          {subtitle ? <Text className="text-ink-soft font-typed text-sm mb-3">{subtitle}</Text> : null}
          {scroll ? <ScrollView style={{ maxHeight: Math.round(height * 0.65) }} contentContainerStyle={{ gap: 10 }}>{children}</ScrollView> : children}
        </View>
      </View>
    </AppModal>
  )
}
